class GiftBoxBuilder {
  constructor(element) {
    this.element = element;

    if (this.element.dataset.initialized === 'true') {
      return;
    }

    this.element.dataset.initialized = 'true';

    this.maxBottles = Number(
      this.element.dataset.maxBottles || 4
    );

    this.formId = this.element.dataset.formId;

    this.textComplete =
      this.element.dataset.textComplete || '';

    this.textRemaining =
      this.element.dataset.textRemaining || '';

    this.textRemainingOne =
      this.element.dataset.textRemainingOne || '';

    this.textValidation =
      this.element.dataset.textValidation || '';

    this.items = Array.from(
      this.element.querySelectorAll('[data-flavour]')
    );

    this.totalElement =
      this.element.querySelector('[data-total]');

    this.messageElement =
      this.element.querySelector('[data-message]');

    this.propertyInputs = Array.from(
      this.element.querySelectorAll(
        '[data-bottle-property]'
      )
    );

    this.counts = {};

    this.items.forEach((item) => {
      this.counts[item.dataset.flavour] = 0;
    });

    this.bindEvents();
    this.update();
  }

  getForm() {
    return document.getElementById(this.formId);
  }

  getSubmitButton() {
    const form = this.getForm();

    if (!form) {
      return null;
    }

    return form.querySelector('[name="add"]');
  }

  bindEvents() {
    this.element.addEventListener('click', (event) => {
      const plusButton =
        event.target.closest('[data-plus]');

      const minusButton =
        event.target.closest('[data-minus]');

      if (!plusButton && !minusButton) {
        return;
      }

      const item =
        event.target.closest('[data-flavour]');

      if (!item) {
        return;
      }

      const flavour = item.dataset.flavour;

      if (plusButton) {
        this.addBottle(flavour);
      }

      if (minusButton) {
        this.removeBottle(flavour);
      }
    });

    const form = this.getForm();

    if (form) {
      form.addEventListener(
        'submit',
        (event) => {
          if (this.getTotal() !== this.maxBottles) {
            event.preventDefault();
            event.stopImmediatePropagation();

            this.showValidationError();
          }
        },
        true
      );
    }
  }

  addBottle(flavour) {
    if (this.getTotal() >= this.maxBottles) {
      return;
    }

    this.counts[flavour] += 1;

    this.update();
  }

  removeBottle(flavour) {
    if (this.counts[flavour] <= 0) {
      return;
    }

    this.counts[flavour] -= 1;

    this.update();
  }

  getTotal() {
    return Object.values(this.counts).reduce(
      (total, count) => total + count,
      0
    );
  }

  getSelectedBottles() {
    const selected = [];

    Object.entries(this.counts).forEach(
      ([flavour, count]) => {
        for (
          let index = 0;
          index < count;
          index += 1
        ) {
          selected.push(flavour);
        }
      }
    );

    return selected;
  }

  updateCounts() {
    const total = this.getTotal();

    this.items.forEach((item) => {
      const flavour = item.dataset.flavour;
      const count = this.counts[flavour];

      const countElement =
        item.querySelector('[data-count]');

      const minusButton =
        item.querySelector('[data-minus]');

      const plusButton =
        item.querySelector('[data-plus]');

      countElement.textContent = count;

      minusButton.disabled = count === 0;

      plusButton.disabled =
        total >= this.maxBottles;
    });
  }

  updateProperties() {
    const selectedBottles =
      this.getSelectedBottles();

    this.propertyInputs.forEach(
      (input, index) => {
        input.value =
          selectedBottles[index] || '';
      }
    );
  }

  getRemainingText(remaining) {
    if (remaining === 1) {
      return this.textRemainingOne;
    }

    return this.textRemaining.replace(
      '__COUNT__',
      String(remaining)
    );
  }

  updateStatus() {
    const total = this.getTotal();

    const remaining =
      this.maxBottles - total;

    this.totalElement.textContent = total;

    if (remaining === 0) {
      this.messageElement.textContent =
        this.textComplete;

      this.element.classList.add(
        'gift-box-builder--complete'
      );

      return;
    }

    this.element.classList.remove(
      'gift-box-builder--complete'
    );

    this.messageElement.textContent =
      this.getRemainingText(remaining);
  }

  updateSubmitButton() {
    const submitButton =
      this.getSubmitButton();

    if (!submitButton) {
      return;
    }

    const complete =
      this.getTotal() === this.maxBottles;

    submitButton.disabled = !complete;

    if (complete) {
      submitButton.removeAttribute(
        'aria-disabled'
      );
    } else {
      submitButton.setAttribute(
        'aria-disabled',
        'true'
      );
    }
  }

  showValidationError() {
    this.messageElement.textContent =
      this.textValidation;

    this.element.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  update() {
    this.updateCounts();
    this.updateProperties();
    this.updateStatus();
    this.updateSubmitButton();
  }
}

function initializeGiftBoxBuilders() {
  document
    .querySelectorAll('[data-gift-box-builder]')
    .forEach((element) => {
      new GiftBoxBuilder(element);
    });
}

initializeGiftBoxBuilders();

document.addEventListener(
  'shopify:section:load',
  initializeGiftBoxBuilders
);